import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m31.986 21.618 6.697-6.62c.962-.952-.482-2.379-1.444-1.427l-6.696 6.62-8.939-8.837L28.3 4.741c.962-.95-.48-2.379-1.443-1.428L20.16 9.927l-3.48-3.44c-.963-.952-2.406.475-1.444 1.426L16.5 9.162l-4.422 4.36a9.653 9.653 0 0 0-.001 13.757l.057.057c-4.487 4.69-4.274 13.99 1.417 17.506a1.056 1.056 0 0 0 1.445-.33 1.03 1.03 0 0 0-.334-1.428c-4.458-2.755-4.64-10.468-1.044-14.281l.815.806a9.902 9.902 0 0 0 6.962 2.851 9.902 9.902 0 0 0 6.962-2.851l4.416-4.36 1.25 1.236c.963.951 2.407-.476 1.444-1.427l-3.48-3.44Z",
      clipRule: "evenodd"
    }
  )
);
var SvgPlugFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PlugFilled_default = SvgPlugFilled;

export { PlugFilled_default as default };
